import {get} from "lodash"
import getCodeFromError from "@irati/utils/services/API/helpers/getCodeFromError"
import GenericErrorCodes from "../../errorCodes/Generic"
import domain from "../../../env/domain"

const alwaysIgnore = [
  GenericErrorCodes.PBERRForbiddenInvalidToken,
  GenericErrorCodes.PBERRConflict,
  GenericErrorCodes.PBERRForbiddenTokenExpired
]

export default function shouldSendCallback(data: any) {
  if (domain.isInternal()) {
    // internal admins keep using direct urls and triggering 404s, just ignore all from internal admin
    return false
  }

  const sentryIgnoreError = get(data, "extra.error.config.sentryIgnoreError", undefined)
  const sentryIgnoreAllErrors = get(data, "extra.error.config.sentryIgnoreAllErrors", false)

  if (sentryIgnoreAllErrors) {
    return false
  }

  const code = getCodeFromError(data?.extra?.error)
  if (Array.isArray(sentryIgnoreError)) {
    if (sentryIgnoreError.indexOf(code) > -1) {
      return false
    }
  }

  if (alwaysIgnore.indexOf(code) > -1) {
    return false
  }

  return true
}
